import { render, staticRenderFns } from "./IconMessageArrow.vue?vue&type=template&id=1d5f1e1c&"
import script from "./IconMessageArrow.vue?vue&type=script&lang=ts&"
export * from "./IconMessageArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports